const isDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/
const isPlainProp = /^\w*$/
const isEscapeChar = /\\(\\)?/g
const isPropName = RegExp(
  // Match anything that isn't a dot or bracket.
  '[^.[\\]]+' + '|' +
  // Or match property names within brackets.
  '\\[(?:' +
    // Match a non-string expression.
    '([^"\'].*)' + '|' +
    // Or match strings (supports escaping characters).
    '(["\'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2' +
  ')\\]'+ '|' +
  // Or match "" as the space between consecutive dots or empty brackets.
  '(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))'
, 'g')
const dotCharCode = '.'.charCodeAt(0)

const isKey = (value, obj) => {
	if (Array.isArray(value)) {
		return false
	}
	const type = typeof value
	if (type === 'number' || type === 'boolean' || value == null) {
		return true
	}
	return isPlainProp.test(value) || !isDeepProp.test(value) || (obj != null && value in Object(obj))
}

const stringToPath = str => {
	const result = []
	if (str.charCodeAt(0) === dotCharCode) {
		result.push('')
	}
	str.replace(isPropName, (match, expression, quote, subString) => {
		let key = match
		if (quote) {
			key = subString.replace(isEscapeChar, '$1')
		} else if (expression) {
			key = expression.trim()
		}
		result.push(key)
	})
	return result
}

export default function toPath(value, obj) {
	if (Array.isArray(value)) {
		return value
	}
	return isKey(value, obj) ? [value] : stringToPath(value)
}

